import React from 'react';
import Button from './Button';
import { ArrowRightIcon } from 'lucide-react';
export const CTASection = () => {
  const WebinarLink = ({
    children
  }: {
    children: React.ReactNode;
  }) => <a href="https://stresslessdogs.nl/meta-mcc-adv" className="text-green-600 hover:text-green-700 hover:underline" data-id="element-17">
      {children}
    </a>;
  return <section className="w-full bg-amber-50 py-12 px-4" data-id="element-18">
      <div className="max-w-4xl mx-auto text-center" data-id="element-19">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800" data-id="element-20">
          Meld je nu aan voor het gratis <WebinarLink data-id="element-21">webinar</WebinarLink>
        </h2>
        <p className="text-lg mb-8 text-gray-700 max-w-2xl mx-auto" data-id="element-22">
          Het <WebinarLink data-id="element-23">webinar</WebinarLink> vindt regelmatig plaats.
          Volledig online. Vanuit je luie stoel. Met een kop koffie of thee. Je
          hond naast je op de bank.
        </p>
        <div className="flex justify-center mb-6" data-id="element-24">
          <a href="https://stresslessdogs.nl/meta-mcc-adv" className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 text-lg" data-id="element-25">
            BEKIJK WEBINAR PLANNING
          </a>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md mb-8 max-w-md mx-auto" data-id="element-26">
          <h3 className="text-xl font-bold mb-4 text-gray-800" data-id="element-27">
            Je hebt alleen nodig:
          </h3>
          <ul className="text-left space-y-3 mb-6" data-id="element-28">
            <li className="flex items-start" data-id="element-29">
              <ArrowRightIcon className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-30" />
              <span data-id="element-31">Een computer, tablet of telefoon</span>
            </li>
            <li className="flex items-start" data-id="element-32">
              <ArrowRightIcon className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-33" />
              <span data-id="element-34">90 minuten van je tijd</span>
            </li>
            <li className="flex items-start" data-id="element-35">
              <ArrowRightIcon className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-36" />
              <span data-id="element-37">Een open mindset</span>
            </li>
          </ul>
          <p className="text-gray-700 mb-6" data-id="element-38">
            Geen technische kennis vereist. Het is zo eenvoudig als YouTube
            kijken.
          </p>
          <a href="https://stresslessdogs.nl/meta-mcc-adv" className="block bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 text-lg text-center" data-id="element-39">
            Ja, ik wil mijn hond écht begrijpen
          </a>
        </div>
        <p className="text-sm text-gray-600 mb-4" data-id="element-40">
          De plekken zijn beperkt om de kwaliteit te waarborgen. Meld je dus
          vandaag nog aan om je plek te reserveren.
        </p>
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-8 max-w-2xl mx-auto" data-id="element-41">
          <p className="text-gray-700 mb-2" data-id="element-42">
            <strong data-id="element-43">P.S.</strong> Honden begrijpen deze manier van communiceren
            direct. Zoals Amee in het <WebinarLink data-id="element-44">webinar</WebinarLink>{' '}
            benadrukt: "Als je hiermee start, dan zul je direct effect zien bij
            je hond." Je hoeft niet weken of maanden te wachten. Vaak zie je al
            binnen dagen—soms zelfs direct—verschil.
          </p>
          <p className="text-gray-700" data-id="element-45">
            <strong data-id="element-46">P.P.S.</strong> Het <WebinarLink data-id="element-47">webinar</WebinarLink> is
            volledig gratis. Er zit geen addertje onder het gras. Amee deelt
            gewoon haar kennis omdat ze wil dat meer honden en baasjes elkaar
            écht begrijpen.
          </p>
        </div>
        <a href="https://stresslessdogs.nl/meta-mcc-adv" className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 text-lg inline-block" data-id="element-48">
          Reserveer nu je gratis plek in het webinar
        </a>
      </div>
    </section>;
};